import { Injectable } from '@angular/core';
import { CustomerAccount } from '@dch/common-business-logic';
import { AnalyticsService } from '@dch/ng-common';

/**
 * A similar service is available as analytics-navigation.directive in @dch/ng-common
 * It was not enough for our use-case because of parameters not available when in the routing module, ex:
 * - the pageName (category) in the category details page
 * - document references that we want to add dynamicaly to the analytics report
 */

@Injectable({
  providedIn: 'root',
})
export class BillingAnalyticsService {
  constructor(private analytics: AnalyticsService) {}

  reportPageImpressionEvent(
    pageName: string,
    documentReference?: string,
    screenMessageInfo?: string,
    pageNameLvl4?: string,
    customerId?: number,
    customerSubsegment?: string,
    customerGlobalId?: string,
    customerMobile?: string
  ): void {
    pageName = pageName.toLowerCase();
    this.reportPageImpressionEventWithPagePrefix(
      pageName,
      documentReference,
      screenMessageInfo,
      `billing.${pageName}`,
      pageNameLvl4 ? `billing.${pageNameLvl4}` : undefined,
      customerId,
      customerSubsegment,
      customerGlobalId,
      customerMobile
    );
  }

  reportPageImpressionEventWithPagePrefix(
    pageName: string,
    documentReference?: string,
    screenMessageInfo?: string,
    pageNameLvl3?: string,
    pageNameLvl4?: string,
    customerId?: number,
    customerSubsegment?: string,
    customerGlobalId?: string,
    customerMobile?: string
  ): void {
    pageName = pageName.toLowerCase();
    this.analytics.reportEvent({
      event: 'page-impression',
      context: documentReference,
      page: {
        name: `mybill.${pageName}`,
        id: `mybill.${pageName}`,
        category: {
          l1: 'myproximus',
          l2: 'my-bill',
          l3: pageNameLvl3,
          l4: pageNameLvl4,
        },
      },
      message: {
        info: screenMessageInfo,
      },
      customer: {
        id: customerId,
        subsegment: customerSubsegment,
      },
      user: {
        gid: customerGlobalId,
        msisdn: customerMobile,
      },
    });
  }
}
